import React from "react";
import { Box } from "@mui/material";

import Vault from "../../../components/Vault";

interface Props {
  itemId: number;
}

/**
 * Files tab — matches Parts/Freight Files TabPanel:
 * white card, Vault with toolbar + autosend on the items table.
 */
export default function ItemFiles({ itemId }: Props) {
  return (
    <Box className="detail-view-card">
      <Vault
        toolbar
        autosend
        path={`items/${itemId}/`}
        source="items"
        id={itemId}
      />
    </Box>
  );
}
